import styled from 'styled-components';
import { InputWithMask } from '@leasequery/lq.react-component-library';

interface ValueInputProps {
  hasError?: boolean;
}

const ValueInputWithMask = styled(InputWithMask)<ValueInputProps>`
  input {
    ${(props): string =>
      props.hasError ? `border-color: ${props.theme.colors.basicRed}` : ''};
  }
`;

export { ValueInputWithMask };
